var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pending"},[_c('h2',{staticClass:"normal",domProps:{"innerHTML":_vm._s(_vm.$t('confirmation.pending.header'))}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('confirmation.pending.description'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }